

export const state = {

    mapType: '', // Current, Historical, Deviation

    mapLayers: [],

    wfsLayers: [],

    newVirtualStationLatLon: {name: '', status: false, latitude: null, longitude: null },
};